export const RECEIVED_CABLES = 'dashboard/CableProduction/RECEIVED_CABLES'
export const RECEIVED_LOCATIONS = 'dashboard/CableProduction/RECEIVED_LOCATIONS'
